import React from "react"
import styled from "@emotion/styled"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

const RADIUS_DESKTOP = 26
const SIZE_DESKTOP = 56

const ThumbnailWrapper = styled.button`
  position: relative;

  &:focus {
    outline: 3px solid blue;
    outline-offset: -3px; /* Adjust to ensure the outline is not cut off */
  }

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${SIZE_DESKTOP}px;
  height: ${SIZE_DESKTOP}px;
  margin: 0 auto;
  cursor: pointer;
  @media (max-width: 345px) {
    transform: translateX(-9px) scale(0.9);
  }

  @media (min-width: 768px) {
    margin: 0 10px;
  }

  &.active {
    background: ${theme.wild.color.nova.base.solid["40"]};
  }
`

const ThumbnailImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  opacity: 0.4;
  //transform: scale(1.03);

  &.active {
    opacity: 1;
  }
`

const Progress = styled.svg`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  transform: rotate(-90deg);

  circle {
    stroke-width: 4px;
    stroke: ${theme.wild.color.nova.brand.accent["80"]};
    stroke-dashoffset: 0;
    animation: dash ${(prop) => prop.speed}ms linear forwards;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0;
    }
  }
`

const DesktopProgress = styled(Progress)`
  circle {
    stroke-dasharray: ${2 * Math.PI * RADIUS_DESKTOP};
    stroke-dashoffset: ${2 * Math.PI * RADIUS_DESKTOP};
  }
`

const Thumbnail = ({
  thumbnail,
  isActive,
  autoplay,
  autoplaySpeed,
  onClick,
  name,
}) => {
  return (
    <ThumbnailWrapper
      className={autoplay && isActive ? "active" : ""}
      onClick={onClick}
    >
      <ThumbnailImage
        src={thumbnail}
        className={isActive ? "active" : ""}
        alt={"Select to view testimonial"}
        role="presentation"
      />
      {autoplay && isActive ? (
        <DesktopProgress
          speed={autoplaySpeed}
          width={SIZE_DESKTOP}
          height={SIZE_DESKTOP}
        >
          <circle
            cx={SIZE_DESKTOP / 2}
            cy={SIZE_DESKTOP / 2}
            r={RADIUS_DESKTOP}
            fill="transparent"
          />
        </DesktopProgress>
      ) : null}
    </ThumbnailWrapper>
  )
}

export default Thumbnail
